import { call, put, takeLatest } from 'redux-saga/effects';
import Survey from '../../api/survey';
import {
  actionTypes,
  getStaticValuesSuccess,
  getSurveySeriesByIdSuccess,
  getSurveySeriesSuccess,
  getSurveySuccess,
  updateSurveySuccess,
} from '../actions/survey';

function* createSurvey(action) {
  try {
    const result = yield call(() => Survey.createSurvey(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* getSurvey(action) {
  try {
    const result = yield call(() => Survey.getSurvey(action.payload));
    yield put(getSurveySuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* updateSurvey(action) {
  try {
    const { id, data } = action.payload;
    const result = yield call(() => Survey.updateSurvey(id, data));
    yield put(updateSurveySuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* getStaticValues() {
  try {
    const result = yield call(() => Survey.getStaticValues());
    yield put(getStaticValuesSuccess(result));
  } catch (error) {
    console.log(error);
  }
}

function* createSurveySeries(action) {
  try {
    const result = yield call(() => Survey.createSurveySeries(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* getSurveySeries(action) {
  try {
    const result = yield call(() => Survey.getSurveySeries(action.payload));
    yield put(getSurveySeriesSuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* getSurveySeriesById(action) {
  try {
    const result = yield call(() => Survey.getSurveySeriesById(action.payload));
    yield put(getSurveySeriesByIdSuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    yield put(getSurveySeriesByIdSuccess({}));
    action.callback(false);
  }
}

function* cloneSurvey(action) {
  try {
    const result = yield call(() => Survey.cloneSurvey(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* closeSurvey(action) {
  try {
    const result = yield call(() => Survey.closeSurvey(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* publishSurvey(action) {
  try {
    const result = yield call(() => Survey.publishSurvey(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* updateSurveySeries(action) {
  try {
    const result = yield call(() => Survey.updateSurveySeries(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* reopenSurvey(action) {
  try {
    const result = yield call(() => Survey.reopenSurvey(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* saveNotes(action) {
  try {
    const result = yield call(() => Survey.saveNotes(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* getCCEmail(action) {
  try {
    const { ccEmail } = yield call(() => Survey.getCCEmail());
    action.callback(ccEmail);
  } catch (error) {
    console.log(error);
  }
}

function* updateCCEmail(action) {
  try {
    const result = yield call(() => Survey.updateCCEmail(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

export default function* surveySaga() {
  yield takeLatest(actionTypes.CREATE_SURVEY, createSurvey);
  yield takeLatest(actionTypes.CREATE_SURVEY_SERIES, createSurveySeries);
  yield takeLatest(actionTypes.GET_SURVEY, getSurvey);
  yield takeLatest(actionTypes.UPDATE_SURVEY, updateSurvey);
  yield takeLatest(actionTypes.GET_STATIC_VALUES, getStaticValues);
  yield takeLatest(actionTypes.GET_SURVEY_SERIES, getSurveySeries);
  yield takeLatest(actionTypes.GET_SURVEY_SERIES_BY_ID, getSurveySeriesById);
  yield takeLatest(actionTypes.CLONE_SURVEY, cloneSurvey);
  yield takeLatest(actionTypes.CLOSE_SURVEY, closeSurvey);
  yield takeLatest(actionTypes.PUBLISH_SURVEY, publishSurvey);
  yield takeLatest(actionTypes.UPDATE_SURVEY_SERIES, updateSurveySeries);
  yield takeLatest(actionTypes.REOPEN_SURVEY, reopenSurvey);
  yield takeLatest(actionTypes.SAVE_NOTES, saveNotes);
  yield takeLatest(actionTypes.GET_CC_EMAIL, getCCEmail);
  yield takeLatest(actionTypes.UPDATE_CC_EMAIL, updateCCEmail);
}
